export default __webpack_public_path__ + "static/media/service6.caf5558e.jpeg";